export default "__VITE_ASSET__3jjxMLpl__"